import type { OrgUnitType } from "./OrgUnitFormModal";

/** Organizasyon birimi satırı (backend hr.orgUnit.list düz çıktısı). */
export interface OrgUnitRow {
  id: string; name: string; code: string | null; type: OrgUnitType;
  parentId: string | null; path: string; depth: number; wbs: string;
  isActive: boolean; isShiftBased: boolean; tesisId: string | null; tesisName: string | null; childCount: number;
}

/** Birim türü → etiket + ikon (renk tek başına anlatmaz: ikon + metin). */
export const ORG_TYPE_META: Record<OrgUnitType, { label: string; icon: string }> = {
  company: { label: "Şirket", icon: "building" },
  division: { label: "Bölge / Direktörlük", icon: "columns" },
  department: { label: "Departman", icon: "users" },
  team: { label: "Ekip", icon: "list2" },
};

export type { OrgUnitType };
